import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import cx from 'classnames';
// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';

// Components
import FormBuilder from '../../../organisms/FormBuilder';
var BodyComponent = function BodyComponent(_ref) {
  var fields = _ref.fields,
    values = _ref.values,
    errors = _ref.errors,
    warnings = _ref.warnings,
    onAction = _ref.onAction,
    contentHeight = _ref.contentHeight,
    sections = _ref.sections,
    className = _ref.className,
    bodyRef = _ref.bodyRef,
    bodyId = _ref.bodyId,
    shouldAvoidFieldValidation = _ref.shouldAvoidFieldValidation,
    useKeyBoardShortcuts = _ref.useKeyBoardShortcuts,
    handleOnScroll = _ref.handleOnScroll,
    isFormDisabled = _ref.isFormDisabled,
    formClassName = _ref.formClassName;
  return /*#__PURE__*/React.createElement("div", {
    id: bodyId,
    className: cx('full-width overflow-y-auto', className),
    style: {
      height: contentHeight
    },
    ref: bodyRef,
    onScroll: handleOnScroll
  }, /*#__PURE__*/React.createElement(FormBuilder, {
    fields: fields,
    values: values,
    errors: errors,
    onAction: onAction,
    sections: sections,
    warnings: warnings,
    shouldAvoidFieldValidation: shouldAvoidFieldValidation,
    useKeyBoardShortcuts: useKeyBoardShortcuts,
    className: cx(formClassName, {
      'is-disabled': isFormDisabled
    })
  }));
};
BodyComponent.propTypes = {
  sections: PropTypes.array,
  errors: PropTypes.object,
  values: PropTypes.object,
  fields: PropTypes.object,
  warnings: PropTypes.object,
  onAction: PropTypes.func,
  contentHeight: PropTypes.number,
  className: PropTypes.string,
  bodyRef: PropTypes.object,
  handleOnScroll: PropTypes.func,
  isFormDisabled: PropTypes.bool,
  formClassName: PropTypes.string
};
BodyComponent.defaultProps = {
  sections: EMPTY_ARRAY,
  errors: EMPTY_OBJECT,
  values: EMPTY_OBJECT,
  fields: EMPTY_OBJECT,
  warnings: EMPTY_OBJECT,
  bodyRef: {},
  onAction: noop,
  contentHeight: 0,
  className: '',
  handleOnScroll: noop,
  isFormDisabled: false,
  formClassName: EMPTY_STRING
};
export default BodyComponent;